export enum SocialType {
  FACEBOOK,
  GOOGLE,
  APPLE
}
